import { useLessonPlayerStore } from '@stores/lessonPlayerStore';
import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import Image from '@base/Image';
import { keyframes } from '@emotion/react';
import { getControlIcon } from '@utils/unacademyIcons/playerHelper';

interface ControlsFeedbackProps {}

const fadeOut = keyframes`
from {
  transform: scale(1.2);
}
to {
  opacity: 0;
  transform: scale(2);
}
`;

const StyledFeedback = styled.div`
  position: absolute;
  z-index: 4000;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;
  background: rgba(0, 0, 0, 0.5);
  height: 40px;
  width: 40px;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 100%;
  animation: ${fadeOut} 0.5s linear 1 normal forwards;
`;

const ControlsFeedback: React.FC<ControlsFeedbackProps> = () => {
  const { isFeedbackVisible, feedbackType } = useLessonPlayerStore();

  const showFeedback = useMemo(
    () => isFeedbackVisible && feedbackType !== null,
    [isFeedbackVisible, feedbackType]
  );

  if (showFeedback)
    return (
      <StyledFeedback>
        <Image
          src={getControlIcon(feedbackType)}
          alt="Forward 10"
          layout="intrinsic"
          width="24px"
          height="24px"
        />
      </StyledFeedback>
    );
  return null;
};

ControlsFeedback.displayName = 'ControlsFeedback';

export default ControlsFeedback;
